import React, { useEffect, useState, useRef, useCallback } from "react"; //eslint-disable-line
import he from "he";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useForm, FormProvider } from "react-hook-form";
import { useMediaQuery } from "react-responsive";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import { v4 as uuidv4 } from "uuid";
import classNames from "classnames";
import {
  eachDayOfInterval,
  eachMonthOfInterval,
  endOfMonth,
  format,
  startOfMonth,
} from "date-fns";
import { es } from "date-fns/locale";
import { Remarkable } from "remarkable";

/* Styles */
import "../../../components/chat/chat.css";

/* Services */
import { fetchAssistantChatGPT } from "../../../services/chat.service";
import {
  getIteractionById,
  getSessionsByUseCase,
} from "../../../services/teacherSession.service";
import {
  classProfileAddListRegisters,
  getAllProfileClass2,
} from "../../../services/profile-class.service";
import { getEnadActivities } from "../../../services/enad.service";

/* Zustand stores */
import useSnackbarStore from "../../../store/snackbarStore";
import useGlobalStore from "../../../store/useGlobalStore";
import useSessionStore from "../../../store/useSessionStore";

/* Components */
import Button from "../../../components/button/button"; 
import Bubble from "../../../components/Bubble/Bubble";
import IdeaPlanBubbleContent from "./ContenBubbles/IdeaPlanBubbleContent";
import UseCaseHistory from "../../../components/UseCaseHistory/UseCaseHistory";
import WeekSessionBubbleContent from "./ContenBubbles/WeekSessionBubbleContent";
import ClassProfileBubbleContent from "./ContenBubbles/ClassProfileBubbleContent";
import WritingContent from "../../../components/globals/WritingContent/WritingContent";
import ObjetivesChoicesBubbleContent from "./ContenBubbles/ObjetivesChoicesBubbleContent";
import ContinuePhase6or7BubbleContent from "./ContenBubbles/ContinuePhase6or7BubbleContent";
import BottomMenuMobile from "../../../components/globals/BottomMenuMobile/BottomMenuMobile";
import InputChatContainer from "../../../components/globals/InputChatContainer/InputChatContainer";
import HelpMeToSelectActivitiesBubbleContent from "./ContenBubbles/HelpMeToSelectActivitiesBubbleContent";
import ExtensiveWritingContent from "../../../components/globals/ExtensiveWritingContent/ExtensiveWritingContent";

/* Utils */
import {
  addCollapsibleBehavior,
  capitalizeFirstLetter,
  exportToDocx,
  extractContentWithinTags,
  htmlToPdf,
} from "../../../utils/Utils";


/* Assets */
import ArrowBack from "../../../assets/icons/arrow_back.svg";
import HistoryEmpty from "../../../assets/icons/history_toggle_off.svg";


/* Hooks */
import useTimer from "../../../hooks/useTimer";




import Popup from "../../../components/popup/popup";
import ActivitySelectorRefactor from "./ActivitySelectorRefactor";
import DesignEnadActivity from "../EnadActivity/DesignEnadActivity";

const DesignEnadClassRefactor = () => {
  /* States */
  const [showExtendedLoadingMessage, setShowExtendedLoadingMessage] = useState(false);
  const [history, setHistory] = useState([]);
  const [showLocalBubble1, setShowLocalBubble1] = useState(false);
  const [currentExplainAcitivty, setCurrentExplainActivity] = useState(null);
  const [showSelectActvityModal, setShowSelectActivityModal] = useState(false);
  const [objectiveGroupOpen, setObjectiveGroupOpen] = useState(false);
  const [objectiveGroupToDisplay, setObjectiveGroupToDisplay] = useState(null);
  const [localValidateGoals, setLocalValidateGoals] = useState([]);
  const [showExplainActivityModal, setShowExplainActivityModal] = useState(false);
  const [selectedClassProfile, setSelectedClassProfile] = useState(null);
  const [selectedKnowledgeArea, setSelectedKnowledgeArea] = useState(null);
  const [objectiveOption, setObjectiveOption] = useState(null);
  const [classProfileList, setClassProfileList] = useState([]);
  const [activityExplainList, setActivityExplainList] = useState([]);
  const [isView, setIsView] = useState(null);
  const [loading, setLoading] = useState(false);
  const [newMessage, setNewMessage] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [statusIteraction, setStatusIteraction] = useState(1);
  const [file] = useState(null);
  const [messagesStep1, setMessagesStep1] = useState([]);
  const [messagesStep2, setMessagesStep2] = useState([]);
  const [messagesStep3, setMessagesStep3] = useState([]);
  const [messages, setMessages] = useState([]);
  const [resMessages, setResMessages] = useState([]);
  const [enadActivities, setEnadActivities] = useState([]);
  const [isChatActive, setIsChatActive] = useState(false);
  const [isEditorOn] = useState(false);
  const { gptSuccess, setCreditAnimateClear} = useGlobalStore();
  const methods = useForm();
  const { watch, setValue, getValues, register } = methods;
  const navigate = useNavigate();
  const { show } = useSnackbarStore();
  const temporalLoadingRef = useRef(false);
  const parentSessionIdRef = useRef(null);
  const sessionIdRef = useRef(null);
  const stepPrompt = useRef(1);
  const chatContainerRef = useRef(null);
  const stepsRef = useRef(1);
  const isMobile = useMediaQuery({ maxWidth: 564 }); //eslint-disable-line
  const { t, i18n } = useTranslation(); //eslint-disable-line
  const currentMonth = watch("month");
  const currentDay = watch("day");

  /* Hooks */
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const sessionId = queryParams.get("sessionId");
  const { user } = useSessionStore();
  const { count, startTimer, resetTimer } = useTimer();


  /* Effects */

  // Observa el contador de tiempo y muestra un mensaje extendido si supera los 30 segundos.
  useEffect(() => {
    if (count > 30) {
      scrollToBottom();
      setShowExtendedLoadingMessage(true);
    }
  }, [count]);

  // Se activa iteraccion 3 cuando se selecciona un mes y un día.
  useEffect(() => {
    if (currentMonth && currentDay) {
      setStatusIteraction(3);
    }
    // eslint-disable-next-line
  }, [currentMonth, currentDay]);

  // Cuando la informacion del usuario esta disponible, se obtiene los perfiles de la clase
  useEffect(() => {
    if (user) {
      setLoading(true);
      mutationClassProfileList.mutate({ email: user?.email });
    }
    // eslint-disable-next-line
  }, [user]);

    // Por cada mensaje obtenido de la IA se hace scroll hacia abajo.
  useEffect(() => {
    scrollToBottom();
    addCollapsibleBehavior();
  }, [messages, statusIteraction, file]);

   // Cuando la modal de la herramienta explicar actividad no esta activa se asegura de borrar los datos temporales.
  useEffect(() => {
    if (!showExplainActivityModal) {
      sessionByIdMutation.mutate(sessionId);
      localStorage.removeItem("temporal_session");
      localStorage.removeItem("temporal_parent_session");
    }
    // eslint-disable-next-line
  }, [sessionId, showExplainActivityModal]);


   // Cuando la respuesta de fetchAssistantChatGPT finaliza, se estucha el guardado en el state resMessages
  useEffect(() => {
    if (resMessages.length) {
      setMessagesByStep(resMessages);
      setNewMessage("");
      if (temporalLoadingRef.current) temporalLoadingRef.current = false;
      const messageAssistands = resMessages.filter(
        (e) => e?.role === "assistant" || e?.type === "ai" || e?.role === "ai"
      );
      const findIteraction6 = resMessages.some(
        (e) =>
          (e?.role === "assistant" || e?.type === "ai" || e?.role === "ai") &&
          (e?.content?.includes("<Activities_Selection>") ||
            e?.data?.content.includes("<Activities_Selection>"))
      );
   
      if (findIteraction6) {
        setStatusIteraction(6);
      }
      if (sessionIdRef.current) {
        sessionByIdMutation.mutate(sessionIdRef.current);
      }
      if (messageAssistands.length) {
        const lastAssistand = messageAssistands[messageAssistands.length - 1];
        setMessages([...messages, { ...lastAssistand }]);
        const contendAssistant =
          lastAssistand?.content || lastAssistand?.data?.content;
        if (contendAssistant?.includes("<validatedgoal>")) {
          setStatusIteraction(7);
          // send(userInput, true, getAssetIdActivities);
        }
      }

      setLoading(false);
    }
  }, [resMessages]); //eslint-disable-line


  useEffect(() => {
    teacherSessionMutation.mutate("enad_class3");
    getEnadActivitiesMutation.mutate();
    // eslint-disable-next-line
  }, []);

  const trackBackEvent = () => {
    if (isMobile) {
      navigate("/");
    }
    setCreditAnimateClear();
  };

  /* Funtions */

  const handleSelectObjectivesGroup = useCallback((goal) => {
    if (localValidateGoals.some((g) => g.id === goal.id)) {
      // Deseleccionar
      setLocalValidateGoals(localValidateGoals.filter((g) => g.id !== goal.id));
    } else {
      // Seleccionar
      setLocalValidateGoals([...localValidateGoals, goal]);
    }
    // eslint-disable-next-line
  }, []);

  const isSelected = (goal) => localValidateGoals.some((g) => g.id === goal.id);

  const teacherSessionMutation = useMutation(getSessionsByUseCase, {
    onSuccess: (res) => {
      setHistory(res);
    },
    onError: () => {},
  });

  const getEnadActivitiesMutation = useMutation(getEnadActivities, {
    onSuccess: (res) => {
      const parseList = res.map((e) => ({
        ...e,
        value: e.id,
        label: e.name,
        show: true,
      }));
      setEnadActivities(parseList);
      setLoading(false);
    },
    onError: () => {},
  });

  const onObjectGroupOpen = useCallback(() => {
    setObjectiveGroupOpen(!objectiveGroupOpen);
    // eslint-disable-next-line
  }, []);

  const generateMonthOptions = () => {
    const months = eachMonthOfInterval({
      start: new Date(2023, 0, 1), // Año y mes de inicio (enero)
      end: new Date(2023, 11, 31), // Año y mes de fin (diciembre)
    });

    return months.map((month, index) => ({
      value: index + 1,
      label: capitalizeFirstLetter(format(month, "MMMM", { locale: es })),
    }));
  };

  const optionMonths = generateMonthOptions();

  const generateDayOptions = () => {
    const days = eachDayOfInterval({
      start: startOfMonth(currentMonth), // Inicio del mes seleccionado
      end: endOfMonth(currentMonth), // Fin del mes seleccionado
    });

    return days.map((day) => ({
      value: format(day, "d"), // Número del día
      label: format(day, "d"), // Número del día
    }));
  };

  const showChat = () => {
    setIsChatActive(!isChatActive);
  };

  const onSelectActivityModalClose = () => {
    setShowSelectActivityModal(false);
  };

  const onExplainActivityModalClose = () => {
    setShowExplainActivityModal(false);
    setCurrentExplainActivity(null);
    const getLocalSessionId = localStorage.getItem("temporal_session");
    const getLocalParentSessionId = localStorage.getItem(
      "temporal_parent_session"
    );
    parentSessionIdRef.current = getLocalParentSessionId;
    navigate(`/design-enad-class?sessionId=${getLocalSessionId}`);
    setShowExplainActivityModal(false);
  };

  const handleCleanObjectiveField = useCallback((currentObjectiveNumber) => {
    setValue(`objective_option${currentObjectiveNumber}`, "");
    // eslint-disable-next-line
  }, []);

  const handleStartIteraction = useCallback((objectiveOptionNumber) => {
    const currentObjectiveOption = getValues(
      `objective_option${objectiveOptionNumber}`
    );
    let studentLevelAmount = null;
    let studentLabels = null;
    let groupType = null;
    let knowledgeArea = null;
    if (selectedClassProfile?.student_level) {
      const parseJsonStudentLevel = JSON.parse(
        selectedClassProfile?.student_level
      );
      const currentStudentLevel = parseJsonStudentLevel[0];
      knowledgeArea = currentStudentLevel?.knowledge_area;
      groupType = currentStudentLevel?.group_type;
      studentLabels = currentStudentLevel?.levels
        ?.map((e) => e.label)
        .join("; ");
      studentLevelAmount = currentStudentLevel?.levels?.reduce(
        (acc, current) => {
          return `${acc}; ${current.label}: ${
            current.studentsNumberGroup
          } Estudiante${Number(current.studentsNumberGroup) > 1 ? "s" : ""} \n`;
        },
        ""
      );
    }
    const userInput = `
    Contexto del grupo
    * Área de enseñanza: ${knowledgeArea}
    * Tipo de agrupación de los estudiantes: ${groupType}
      * Nivel(es) de los estudiantes: ${studentLabels}
      * Número de estudiantes en cada nivel:
      ${studentLevelAmount}
    * Consideraciones para este grupo: ${
      selectedClassProfile?.special_considerations
    }
    * Sesión de la semana a planear: Diciembre 2, 2024
    * Ideas del docente para esta sesión: ${newMessage}
    ${
      objectiveOption
        ? `
       ${
         objectiveOption === 1
           ? `Objetivo(s) de aprendizaje de esta sesión para validar: ${currentObjectiveOption}`
           : ""
       }
        ${
          objectiveOption === 2
            ? `Habilidades o conocimientos que deseo que los estudiantes adquieran en esta sesión: ${currentObjectiveOption}`
            : ""
        }
      `
        : ""
    }
    `;

    setStatusIteraction(5);
    send(userInput);
    // eslint-disable-next-line
  }, []);

  const hiddenChat = () => {
    setIsChatActive(!isChatActive);
  };

  const scrollToBottom = () => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight + 300;
    }
  };

  const onShowLocalBubble1 = useCallback(() => {
    setShowLocalBubble1(true);
    setTimeout(() => {
      scrollToBottom();
    }, 0);
  }, []);

  const conditions = [
    "<stage_1>",
    "<stage_2>",
    "<stage_3>",
    "contextoUsuario",
    "ContextoClase",
    "Contexto del grupo",
    "Eres una asistente para docentes",
  ];

  const getMessagesByStep = (currentStep) => {
    switch (currentStep) {
      case 1:
        return messagesStep1;
      case 2:
        return messagesStep2;
      case 3:
        return messagesStep3;
      default:
        return 1;
    }
  };

  const cleanHTML = (html) => {
    // Crear un contenedor temporal para el HTML
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    // Eliminar los botones con la clase 'chat_option-button'
    const buttons = tempDiv.querySelectorAll(".chat_option-button");
    buttons.forEach((button) => button.remove());

    // Eliminar los contenedores de botones con la clase 'option-card-button-container'
    const buttonContainers = tempDiv.querySelectorAll(
      ".option-card-button-container"
    );
    buttonContainers.forEach((container) => container.remove());

    // Devolver el HTML limpio
    return tempDiv.innerHTML;
  };

  const onExportToWord = async (currentContent) => {
    const md = new Remarkable({
      html: true,
      breaks: true,
      typographer: true,
    });

    let html = md.render(currentContent);
    html = he.decode(html);
    await exportToDocx(html, "Explicar actividad ENAd");
  };

  const onDownloadPDF = async (currentContent) => {
    const md = new Remarkable({
      html: true,
      breaks: true,
      typographer: true,
    });

    let html = md.render(cleanHTML(currentContent));

    html = he.decode(html);

    await htmlToPdf(
      "Planear una sesión ENAd",
      `${user?.first_name || ""} ${user?.last_name || ""}`.trim(),
      "Explicar actividad ENAd",
      html,
      true
    );
  };

  const toggleClass = () => {
    setIsActive(!isActive);
  };

  const onBackToEnadTool = (
    currentExplainActivityContent,
    activityExplainName
  ) => {
    setActivityExplainList((prev) => [...prev, currentExplainActivityContent]);

    const activityBoxes = document?.querySelectorAll(".activity-box");
    if (activityBoxes.length) {
      activityBoxes.forEach((box, index) => {
        const h4 = box.querySelector("h4");
        let color = "";
        if (h4 && h4.textContent?.includes("Inicio")) {
          color = "#3FB2E3";
        }
        if (h4 && h4.textContent?.includes("Desarrollo")) {
          color = "#eac176";
        }
        if (h4 && h4.textContent?.includes("Cierre")) {
          color = "#78af64";
        }
        const getH5TagElement = box.querySelector("h5");
        if (getH5TagElement?.textContent) {
          const cleanedPTagActivityName = getH5TagElement.textContent
            .replace(/\*\*/g, "")
            .trim();
          if (cleanedPTagActivityName === activityExplainName) {
            const buttons = box.querySelectorAll("button");
            buttons.forEach((button, i) => {
              if (button.classList.contains("selected")) {
                button.textContent = "Actividad explicada";
                button.style.pointerEvents = "none";
                button.style.border = `2px solid ${color}`;
                button.style.color = color;
              }
            });
          }
        }
      });
    }

    const activityPhaseBoxes = document?.querySelectorAll(
      ".activity-phase-box"
    );

    if (activityPhaseBoxes.length) {
      activityPhaseBoxes.forEach((box, index) => {
        const getPTagElement = box.querySelector("h5");
        if (getPTagElement?.textContent) {
          const cleanedPTagActivityName = getPTagElement.textContent
            .replace(/\*\*/g, "")
            .trim();
          if (cleanedPTagActivityName === activityExplainName) {
            const h4 = box.querySelector("h4");

            let color = "";
            if (h4 && h4.textContent?.includes("Inicio")) {
              color = "#3FB2E3";
            }
            if (h4 && h4.textContent?.includes("Desarrollo")) {
              color = "#eac176";
            }
            if (h4 && h4.textContent?.includes("Cierre")) {
              color = "#78af64";
            }
            const buttons = box.querySelectorAll("button");
            buttons.forEach((button, i) => {
              if (button.classList.contains("selected")) {
                button.textContent = "Actividad explicada";
                button.style.pointerEvents = "none";
                button.style.border = `2px solid ${color}`;
                button.style.color = color;
                button.style.backgroundColor = "transparent";
              }
            });
          }
        }
      });
    }
    setShowExplainActivityModal(false);
    setCurrentExplainActivity(null);
    const getLocalSessionId = localStorage.getItem("temporal_session");
    const getLocalParentSessionId = localStorage.getItem(
      "temporal_parent_session"
    );
    parentSessionIdRef.current = getLocalParentSessionId;
    navigate(`/design-enad-class?sessionId=${getLocalSessionId}`);
    setShowExplainActivityModal(false);
  };

  const handleOption = (op, isExplainAcitvity = false) => {
    let knowledgeArea = null;
    if (selectedClassProfile?.student_level) {
      const parseJsonStudentLevel = JSON.parse(
        selectedClassProfile?.student_level
      );
      const currentStudentLevel = parseJsonStudentLevel[0];
      knowledgeArea = currentStudentLevel?.knowledge_area;
    }

    if (op === "Ya sé qué actividades ENAd quiero integrar") {
      setShowSelectActivityModal(true);
      return;
    }
    if (isExplainAcitvity) {
      setCurrentExplainActivity({
        name: op.trim(),
        knowledgeArea,
      });
      localStorage.setItem("temporal_session", sessionId);
      localStorage.setItem(
        "temporal_parent_session",
        parentSessionIdRef.current
      );
      navigate("/design-enad-class");
      setShowExplainActivityModal(true);
      return;
    }

    if (stepPrompt.current === 2) {
      send(op);
      return;
    }
    if (stepPrompt.current === 3 || stepPrompt.current === 4) {
      send(op);
      return;
    }
    // send(op);
  };

  const mutationClassprofileAddList = useMutation(
    classProfileAddListRegisters,
    {
      onSuccess: (data) => {
        show(
          "Estos objetivos de aprendizaje han sido agregados correctamente al perfil de tu grupo"
        );
      },
      onError: (error) => {},
    }
  );

  const extractValidateGoalOptions = (validatedGoals) => {
    const regex = /<option>\s*([\s\S]*?)\s*<\/option>/g;
    const matches = [];
    let match;
    while ((match = regex.exec(validatedGoals)) !== null) {
      matches.push(match[1].trim());
    }
    return matches;
  };

  const handleHelMeToSelectActivities = useCallback(() => {
    let studentLevelAmount = null;
    let studentLabels = null;
    let groupType = null;
    let knowledgeArea = null;
    stepPrompt.current = 2;
    if (selectedClassProfile?.student_level) {
      const parseJsonStudentLevel = JSON.parse(
        selectedClassProfile?.student_level
      );
      const currentStudentLevel = parseJsonStudentLevel[0];
      knowledgeArea = currentStudentLevel?.knowledge_area;
      groupType = currentStudentLevel?.group_type;
      studentLabels = currentStudentLevel?.levels
        .map((e) => e.label)
        .join("; ");
      studentLevelAmount = currentStudentLevel?.levels?.reduce(
        (acc, current) => {
          return `${acc}; ${current.label}: ${
            current.studentsNumberGroup
          } Estudiante${Number(current.studentsNumberGroup) > 1 ? "s" : ""} \n`;
        },
        ""
      );
    }
    let messageAssistand = messages.find(
      (e) =>
        (e?.role === "assistant" || e?.type === "ai" || e?.role === "ai") &&
        (e?.content?.includes("<validatedgoal>") ||
          e?.data?.content?.includes("<validatedgoal>"))
    );
    let validatedGoals = "";
    if (messageAssistand) {
      validatedGoals = extractContentWithinTags(
        messageAssistand?.content || messageAssistand?.data?.content,
        "validatedgoal"
      );
      const optionsArray = extractValidateGoalOptions(validatedGoals);
      if (optionsArray?.length) {
        mutationClassprofileAddList.mutate({
          email: user?.email,
          classProfileId: selectedClassProfile.id,
          objectives: optionsArray,
        });
      }
    }

    if (showLocalBubble1 && localValidateGoals.length) {
      const currentGoalList = localValidateGoals
        .map((e) => e.description)
        .join(", ");

      validatedGoals = currentGoalList;
    }

    const userInput = `
        Contexto del grupo
        * Área de enseñanza: ${knowledgeArea}
        * Tipo de agrupación de los estudiantes: ${groupType}
          * Nivel(es) de los estudiantes: ${studentLabels}
          * Número de estudiantes en cada nivel:
          ${studentLevelAmount}${studentLevelAmount}
        * Consideraciones para este grupo: ${selectedClassProfile?.special_considerations}
        * Sesión de la semana a planear: Diciembre 2, 2024
        * Objetivos de aprendizaje previamente validados para planear la sesión: ${validatedGoals}
        * Retroalimentación de las sesiones anteriores: Pueden ser más participativas
        * Ayúdame a seleccionar las actividades ENAd: Selecciona las actividades que debo integrar para esta sesión.
        * Documento adjunto: (enviar documento JSON que contiene todas las actividades).
        `;

    send(userInput, true);
    // eslint-disable-next-line
  }, []);

  const getCurrentStepByUseCase = (slug) => {
    switch (slug) {
      case "enad_class1":
        return 1;
      case "enad_class2":
        return 2;
      case "enad_class3":
        return 3;
      case "enad_class4":
        return 4;
      default:
        return 1;
    }
  };

  const mutationClassProfileList = useMutation(getAllProfileClass2, {
    onSuccess: (res) => {
      setClassProfileList(res);
      setLoading(false);
    },
    onError: () => {
      setLoading(false);
    },
  });

  const sessionByIdMutation = useMutation(getIteractionById, {
    onSuccess: (data) => {
      if (data?.data) {
        if (!resMessages.length) {
          if (data.data?.classProfile) {
            setValue("courses", data.data?.classProfile);
            setSelectedClassProfile(data.data?.classProfile);
            if (data.data?.classProfile?.student_level) {
              const parseJsonStudentLevel = JSON.parse(
                data.data?.classProfile?.student_level
              );
              const currentStudentLevel = parseJsonStudentLevel[0];
              setSelectedKnowledgeArea(currentStudentLevel?.knowledge_area);
            }
          }
          const currentStepMessages = [];
          const currentStep = getCurrentStepByUseCase(
            data.data.superPower.slug
          );

          stepPrompt.current = currentStep;
          const historyStep1Messages = data?.data?.messages;
          currentStepMessages.push({
            step: currentStep,
            messages: historyStep1Messages,
          });
          parentSessionIdRef.current = data?.data?.parent_session_id || null;
          if (data.history.length) {
            data.history.forEach((element) => {
              const historyStepMessages = element.messages;
              currentStepMessages.push({
                step: getCurrentStepByUseCase(element.superPower.slug),
                messages: historyStepMessages,
              });
            });
          }
          const satinizedMessages = [];
          currentStepMessages
            .sort((a, b) => a.step - b.step)
            .forEach((e) => {
              satinizedMessages.push(...e.messages);
              setMessagesByInitialStep(e.step, e.messages);
            });
          setMessages(satinizedMessages);
          setStatusIteraction(5);
          const findIteraction6 = satinizedMessages.some(
            (e) =>
              (e?.role === "assistant" ||
                e?.type === "ai" ||
                e?.role === "ai") &&
              (e?.content.includes("<Activities_Selection>") ||
                e?.data?.content.includes("<Activities_Selection>"))
          );
          const findIteraction7 = satinizedMessages.some(
            (e) =>
              (e?.role === "assistant" ||
                e?.type === "ai" ||
                e?.role === "ai") &&
              (e?.content.includes("<validatedgoal>") ||
                e?.data?.content.includes("<validatedgoal>"))
          );
          if (findIteraction6) {
            setStatusIteraction(6);
          }
          if (findIteraction7) {
            setStatusIteraction(7);
          }
        } else {
          parentSessionIdRef.current = data?.data?.parent_session_id || null;
        }
      }
    },
    onError: (error) => {},
  });

  const mutation = useMutation(fetchAssistantChatGPT, {
    onSuccess: (res) => {

      resetTimer();
      setShowExtendedLoadingMessage(false);
      setLoading(false);
      setResMessages(res?.messages);
      scrollToBottom();
    },
    onError: () => {
      resetTimer();
      setShowExtendedLoadingMessage(false);
      setLoading(false);
    },
  });

  const setMessagesByStep = (currentMessages) => {
    switch (stepsRef.current) {
      case 1:
        setMessagesStep1(currentMessages);
        break;
      case 2:
        setMessagesStep2(currentMessages);
        break;
      case 3:
        setMessagesStep3(currentMessages);
        break;
      default:
        return 1;
    }
  };

  const setMessagesByInitialStep = (initialStep, currentMessages) => {
    switch (initialStep) {
      case 1:
        setMessagesStep1(currentMessages);
        break;
      case 2:
        setMessagesStep2(currentMessages);
        break;
      case 3:
        setMessagesStep3(currentMessages);
        break;
      default:
        return 1;
    }
  };

  const handleKnowSelectActivities = (currentActivityList) => {
    let studentLevelAmount = null;
    let studentLabels = null;
    let groupType = null;
    let knowledgeArea = null;
    stepPrompt.current = 2;
    if (selectedClassProfile?.student_level) {
      const parseJsonStudentLevel = JSON.parse(
        selectedClassProfile?.student_level
      );
      const currentStudentLevel = parseJsonStudentLevel[0];
      knowledgeArea = currentStudentLevel?.knowledge_area;
      groupType = currentStudentLevel?.group_type;
      studentLabels = currentStudentLevel?.levels
        .map((e) => e.label)
        .join("; ");
      studentLevelAmount = currentStudentLevel?.levels?.reduce(
        (acc, current) => {
          return `${acc}; ${current.label}: ${
            current.studentsNumberGroup
          } Estudiante${Number(current.studentsNumberGroup) > 1 ? "s" : ""} \n`;
        },
        ""
      );
    }
    const messageAssistand = messages.find(
      (e) =>
        (e?.role === "assistant" || e?.type === "ai" || e?.role === "ai") &&
        (e?.content?.includes("<validatedgoal>") ||
          e?.data?.content?.includes("<validatedgoal>"))
    );
    let validateGoals = "";
    if (messageAssistand) {
      validateGoals = extractContentWithinTags(
        messageAssistand?.content || messageAssistand?.data?.content,
        "validatedgoal"
      );
      const optionsArray = extractValidateGoalOptions(validateGoals);
      if (optionsArray?.length) {
        mutationClassprofileAddList.mutate({
          email: user?.email,
          classProfileId: selectedClassProfile.id,
          objectives: optionsArray,
        });
      }
    }
    if (showLocalBubble1 && localValidateGoals.length) {
      const currentGoalList = localValidateGoals
        .map((e) => e.description)
        .join(", ");

      validateGoals = currentGoalList;
    }

    const userInput = `
        Contexto del grupo
        * Área de enseñanza: ${knowledgeArea}
        * Tipo de agrupación de los estudiantes: ${groupType}
          * Nivel(es) de los estudiantes: ${studentLabels}
          * Número de estudiantes en cada nivel:
          ${studentLevelAmount}
        * Consideraciones para este grupo: ${selectedClassProfile?.special_considerations}
        * Sesión de la semana a planear: Noviembre 14, 2024
        * Objetivos de aprendizaje previamente validados para planear la sesión: ${validateGoals}
        * Retroalimentación de las sesiones anteriores: Pueden ser más participativas
        * Ayúdame a seleccionar las actividades ENAd: Selecciona las actividades que debo integrar para esta sesión.
        * Documento adjunto: (enviar documento JSON que contiene todas las actividades).
        * Estas son las actividades ENAd que quiero integrar en la sesión:
        ${currentActivityList}
        `;

    setShowSelectActivityModal(false);
    send(userInput, true);
  };

  const send = (message, newSession = false, otherMessage = null) => {
    startTimer();
    if (message && message.trim() !== "") {
      const payload = {
        role: "user",
        content: message === "N/A" ? "" : message,
      };
      getMessagesByStep(stepsRef.current); // analizar funcion para borrar o mantener
      setLoading(true);
      const currrentMessagesList = [...messages, { ...payload }];
      if (otherMessage) {
        currrentMessagesList.push(otherMessage);
      }
      setMessages(currrentMessagesList);
      setNewMessage("");

      if (!sessionId) {
        sessionIdRef.current = uuidv4();
        navigate(`/design-enad-class?sessionId=${sessionIdRef.current}`);
      }
      if (sessionId && newSession) {
        parentSessionIdRef.current = sessionId;
        sessionIdRef.current = uuidv4();
        navigate(`/design-enad-class?sessionId=${sessionIdRef.current}`);
      }
      temporalLoadingRef.current = true;
      mutation.mutate({
        messages: [payload], //eslint-disable-line
        type: `enad_class${stepPrompt.current}`,
        session_id: (!newSession && sessionId) || sessionIdRef.current,
        parent_session_id: parentSessionIdRef.current || null,
        use_case_id: null,
        lang: i18n.language,
        class_profile_id: selectedClassProfile?.id || null,
        asset_ids: [],
        response_type: null,
        response_schema: null,
      });
    }
  };

  const sendMessage = () => {
    if (newMessage && newMessage.trim() !== "") {
      if (statusIteraction === 3) {
        const payload = {
          role: "user",
          content: newMessage,
        };
        setMessages([...messages, { ...payload }]);
        setNewMessage("");
        setStatusIteraction(5);
      } else {
        send(newMessage);
      }
    }
  };

  const handleSelectClassProfile = useCallback((row) => {
    setSelectedClassProfile((_value) => (_value?.id === row?.id ? null : row));
    if (row?.student_level) {
      const parseJsonStudentLevel = JSON.parse(row?.student_level);
      const currentStudentLevel = parseJsonStudentLevel[0];
      setSelectedKnowledgeArea(currentStudentLevel?.knowledge_area);
    }
    setStatusIteraction(2);
    // eslint-disable-next-line
  }, []);

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      if (e.shiftKey || e.ctrlKey) {
        // Permite el salto de línea con Shift+Enter o Ctrl+Enter
        return;
      } else {
        // Evita el comportamiento predeterminado de "Enter" en un textarea (añadir una nueva línea)
        e.preventDefault();
        sendMessage();
      }
    }
  };

  const startPhase6or7 = useCallback((nextStep) => {
    let userMessage = "";
    if (nextStep === 3) {
      userMessage = "Revisemos juntos el detalle de cada actividad";
    }
    if (nextStep === 4) {
      userMessage = "Genera el detalle de cada actividad automáticamente";
    }
    const userMessages = messages.filter(
      (e) =>
        (e.role === "user" || e.role === "human" || e.type === "human") &&
        (e.content.includes("Contexto del grupo") ||
          e.data?.content.includes("Contexto del grupo"))
    );
    const aiMessages = messages.filter(
      (e) => e.role === "assistant" || e.role === "ai" || e.type === "ai"
    );

    if (userMessages.length && aiMessages.length) {
      const lastUserMessage = userMessages[userMessages.length - 1];
      const lastAiMessage = aiMessages[aiMessages.length - 1];

      const lastUserInput =
        lastUserMessage?.content || lastUserMessage?.data?.content;
      const lastAiInput =
        lastAiMessage?.content || lastAiMessage?.data?.content;
      const activitieSelection = extractContentWithinTags(
        lastAiInput,
        "Activities_Selection"
      );
      const userInput = `${lastUserInput} 
      * Actividades a seleccionadar para integrar en la sesión: ${activitieSelection}
      * Explicación existente para actividades seleccionadas: 
      ${activityExplainList.join(" ")}
      `;

      stepPrompt.current = nextStep;
      setStatusIteraction(8);
      send(userInput, true, { role: "user", content: userMessage });
    }
    // eslint-disable-next-line
  }, []);

  const handleSelectObjectiveOption = useCallback((currentOption) => {
    setObjectiveOption((prevOption) =>
      currentOption === prevOption ? null : currentOption
    );
  }, []);

  const toggleView = (buttonName, data) => {
    navigate(`/design-enad-class?sessionId=${data.session_id}`);
    setIsView(buttonName);
    if (isActive) {
      toggleClass();
    }
  };

  const handleCreateGroup = useCallback((row) => {
    setSelectedClassProfile(row);
    if (row?.student_level) {
      const parseJsonStudentLevel = JSON.parse(row?.student_level);
      const currentStudentLevel = parseJsonStudentLevel[0];
      setSelectedKnowledgeArea(currentStudentLevel?.knowledge_area);
    }
    setStatusIteraction(2);
    mutationClassProfileList.mutate({ email: user?.email });
    // eslint-disable-next-line
  }, []);

  const filteredMessages = messages
    ?.filter(
      (e) =>
        !conditions.some(
          (stage) =>
            e?.content?.includes(stage) || e?.data?.content.includes(stage)
        )
    )
    .filter((e) => e?.content || e?.data?.content)
    .map((e) => ({ ...e, id: uuidv4() }));
  const findUserMessages = filteredMessages.filter(
    (e) => e?.role === "user" || e?.role === "human" || e?.type === "human"
  );
  const hasAiMessages = filteredMessages.filter(
    (e) => e?.role === "assistant" || e?.role === "ai" || e?.type === "ai"
  );
  const firstUserMessage = findUserMessages.length ? findUserMessages[0] : null;
  const firstAiMessage = hasAiMessages.length ? hasAiMessages[0] : null;

  const staticFormatedTime = firstAiMessage?.createdAt
    ? format(new Date(firstAiMessage?.createdAt), "hh:mm a")
    : "";

  return (
    <>
      {!isMobile && (
        <div className="back-button">
          <Link to={"/"} className="back-button_arrow" onClick={trackBackEvent}>
            <img src={ArrowBack} className="" alt="" />
            {t("inicio")}
          </Link>
          <span className="back_button_root">{t("classText1")} /</span>
          <span className="back_button_page">{t("enad_clase_titulo")}</span>
        </div>
      )}
      <div
        className={classNames("wrapper editor", {
          "z-10": showExplainActivityModal || showSelectActvityModal,
        })}
      >
        {/* Historial */}
        <div
          className={`sidebar_history !h-auto max-h-desktopWrapper xl:max-w-96 xl:min-w-80 ${
            isActive ? "active" : ""
          }`}
        >
          <h6 className="blue-text sidebar-title">{t("historialTitulo")}</h6>
          {history.length ? (
            <UseCaseHistory
              history={history}
              sessionId={null}
              isView={isView}
              toggleView={toggleView} //eslint-disable-line
            />
          ) : (
            <>
              <div className="history_empty">
                <img src={HistoryEmpty} alt="empty" />
                <p className="blue-text">{t("historialTituloVacio")}</p>
              </div>
            </>
          )}
          <Button
            label="Cerrar"
            variant="primary-outline"
            onClick={toggleClass}
          />
        </div>

        {/* Chat */}
        <div
          className={classNames(
            "h-full w-full sm-max:max-h-90/100 flex flex-col justify-end md:gap-4 chat-sticky",
            {
              active: isChatActive,
              "xl:max-w-100": isEditorOn,
            }
          )}
        >
          <div
            ref={chatContainerRef}
            className={`flex flex-col flex-grow justify-end h-0 overflow-y-auto relative sm-max:px-0 sm-max:pt-0 sm-max:pb-4 sm-max:bg-transparent ${
              isEditorOn && "px-1 pt-1 pb-3 "
            }`}
          >
            <div className="chat_wrapper-scroll pr-2">
              <FormProvider {...methods}>
                <form className="h-auto">
                   {/* Burbujas estatica */}
                  <Bubble
                    isDisabled={messages.length}
                    message={{ type: "ai" }}
                    manualFormatedTime={staticFormatedTime || null}
                  >
                    <ClassProfileBubbleContent
                      selectedClassProfile={selectedClassProfile}
                      classProfileList={classProfileList}
                      handleSelectClassProfile={handleSelectClassProfile}
                      handleCreateGroup={handleCreateGroup}
                    />
                  </Bubble>
                   {/* Burbujas estatica */}
                  {statusIteraction >= 2 && (
                    <Bubble
                      isDisabled={messages.length}
                      message={{ type: "ai" }}
                      manualFormatedTime={staticFormatedTime || null}
                    >
                      <WeekSessionBubbleContent
                        optionMonths={optionMonths}
                        optionDays={generateDayOptions()}
                      />
                    </Bubble>
                  )}
                  {/* Burbujas estatica */}
                  {statusIteraction >= 3 && (
                    <Bubble
                      isDisabled={loading || statusIteraction >= 5}
                      message={{ type: "ai" }}
                      manualFormatedTime={staticFormatedTime || null}
                    >
                      <IdeaPlanBubbleContent />
                    </Bubble>
                  )}
                </form>
              </FormProvider>

              {/* Burbujas principales de iteraccion */}
              {statusIteraction >= 5 && (
                <>
                  {filteredMessages?.map((message, i) => {
                    const currentMessage = message?.content || message?.data?.content;
                    const currentRole = message?.role || message?.type;
                    const fotmatedTime = message?.createdAt ? format(new Date(message?.createdAt), "hh:mm a") : null;
                    if ( firstUserMessage && firstUserMessage.id === message.id ) {
                      return (
                        <>
                          <Bubble
                            message={message}
                            isEditorOn={isEditorOn}
                            handleOption={handleOption}
                          />
                          <Bubble
                            isDisabled={
                              loading ||
                              (localValidateGoals.length && showLocalBubble1) ||
                              hasAiMessages.length
                            }
                            message={{ type: "ai" }}
                            manualFormatedTime={staticFormatedTime || null}
                          >
                            <ObjetivesChoicesBubbleContent
                              register={register}
                              objectiveOption={objectiveOption}
                              handleSelectObjectiveOption={
                                handleSelectObjectiveOption
                              }
                              handleCleanObjectiveField={
                                handleCleanObjectiveField
                              }
                              handleStartIteraction={handleStartIteraction}
                              selectedClassProfile={selectedClassProfile}
                              objectiveGroupOpen={objectiveGroupOpen}
                              onObjectGroupOpen={onObjectGroupOpen}
                              objectiveGroupToDisplay={objectiveGroupToDisplay}
                              handleSelectObjectivesGroup={
                                handleSelectObjectivesGroup
                              }
                              isSelected={isSelected}
                              setObjectiveGroupToDisplay={
                                setObjectiveGroupToDisplay
                              }
                              onShowLocalBubble1={onShowLocalBubble1}
                              localValidateGoals={localValidateGoals}
                            />
                          </Bubble>
                          {showLocalBubble1 && (
                            <HelpMeToSelectActivitiesBubbleContent
                              setShowSelectActivityModal={
                                setShowSelectActivityModal
                              }
                              handleHelMeToSelectActivities={
                                handleHelMeToSelectActivities
                              }
                              stepPrompt={stepPrompt}
                              currentFormatedTime={format(
                                new Date(),
                                "hh:mm a"
                              )}
                            />
                          )}
                        </>
                      );
                    }

                    if (["assistant", "ai"].includes(currentRole) && currentMessage.includes("<validatedgoal>")) {
                      return (
                        <HelpMeToSelectActivitiesBubbleContent
                          setShowSelectActivityModal={setShowSelectActivityModal}
                          handleHelMeToSelectActivities={handleHelMeToSelectActivities}
                          stepPrompt={stepPrompt}
                          currentFormatedTime={fotmatedTime}
                        />
                      );
                    }
                    if ( ["assistant", "ai"].includes(currentRole) && currentMessage.includes("<Activities_Selection>")) {
                      return (
                        <Bubble
                          isDisabled={loading || statusIteraction >= 8}
                          message={{ type: "ai" }}
                          manualFormatedTime={fotmatedTime || null}
                        >
                          <ContinuePhase6or7BubbleContent
                            startPhase6or7={startPhase6or7}
                          />
                        </Bubble>
                      );
                    }
                    return (
                      <Bubble
                        message={message}
                        isEditorOn={isEditorOn}
                        handleOption={handleOption}
                        onDownloadPDF={onDownloadPDF}
                        onExportToWord={onExportToWord}
                      />
                    );
                  })}
                  {(loading || temporalLoadingRef.current) && (
                    <Bubble message={{ type: "ai" }}>
                      <WritingContent
                        showExtendedLoadingMessage={showExtendedLoadingMessage}
                      />
                    </Bubble>
                  )}
                  {(loading || temporalLoadingRef.current) &&
                    showExtendedLoadingMessage && (
                      <Bubble message={{ type: "ai" }}>
                        <ExtensiveWritingContent />
                      </Bubble>
                    )}
                </>
              )}
            </div>
          </div>

          {statusIteraction >= 3 && !isEditorOn && (
            <InputChatContainer
              newMessage={newMessage}
              sendMessage={sendMessage}
              loading={loading}
              setNewMessage={setNewMessage}
              handleKeyPress={handleKeyPress}
              temporalLoadingRef={temporalLoadingRef}
            />
          )}
          <div className="md:hidden mt-6 w-full flex items-center justify-center">
            <Button
              label="Cerrar"
              variant="primary-outline"
              onClick={hiddenChat}
            />
          </div>
        </div>
      </div>
      {/* Mobile Bottom navbar */}
      {isMobile && (
        <BottomMenuMobile
          showChat={showChat}
          trackBackEvent={trackBackEvent}
          gptSuccess={gptSuccess}
          toggleClass={toggleClass}
        />
      )}
      <Popup
        isOpen={showSelectActvityModal}
        onClose={onSelectActivityModalClose}
        customClassName="!max-w-[95%] !h-[95%] !w-full"
      >
        <ActivitySelectorRefactor
          enadActivities={enadActivities}
          onSelectActivities={handleKnowSelectActivities}
          selectedKnowledgeArea={selectedKnowledgeArea}
        />
      </Popup>
      <Popup
        isOpen={showExplainActivityModal}
        onClose={onExplainActivityModalClose}
        customClassName="!max-w-[95%] !h-[95%] !w-full"
      >
        <DesignEnadActivity
          externalActivity={currentExplainAcitivty}
          onBackToEnadTool={onBackToEnadTool}
        />
      </Popup>
    </>
  );
};

export default DesignEnadClassRefactor;
